import promotion from '@resources/js/components/promotion'
import initJSLinks from "@resources/js/js-links";
import BcomSearchForm from '@resources/js/components/BcomSearchForm';
import '@resources/js/analytics'


promotion({
    links: {
        active: !!shared.options.dest_id
    },
    backbtn: {
        active: !!shared.options.bbcl && !!shared.options.dest_id
    },
    tab_change: {
        active: !!shared.options.dest_id
    },
    popup: {
        active: !!shared.options.dest_id
    }
})

initJSLinks()

if (document.querySelector('#search-form'))
    new BcomSearchForm('#search-form')
